import { TranslocoService } from '@ngneat/transloco';
import { StatusTagConfiguration } from '@platform-frontend/ui-tools';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';
import { BookedStatus } from './booked-status';

export const BOOKED_STATUS_TAG_CONFIGURATION: (translocoService: TranslocoService) => StatusTagConfiguration<BookedStatus> = (
  translocoService: TranslocoService
) => ({
  status: 'BOOKED',
  class: 'info',
  icon: 'time-duo',
  tagText: translocoService.selectTranslate('asset.bookingStatusTags.bookedStatus', {}, MARKETPLACE_TRANSLOCO_SCOPE)
});
